import api from "./axios";

/**
 * Tipul REAL al profilului, identic cu DB + backend
 */
export type CompanyDto = {
  name: string;
  description: string;
  domains: string[];
};

export interface ProfileUpdatePayload {
  headline?: string;
  bio?: string;
  country?: string;
  city?: string;

  affiliation?: string;
  profession?: string;
  university?: string;

  faculty?: string;

  expertAreas?: string[];

  expertise?: { area: string; description: string }[];

  resources?: { title: string; description: string; url: string }[];

  companies?: CompanyDto[];


  companyName?: string;
  companyDescription?: string;
  companyDomains?: string[];

  availability?: "FULL_TIME" | "PART_TIME" | "WEEKENDS";
  experienceLevel?: "JUNIOR" | "MID" | "SENIOR";
  openToProjects?: boolean;
  openToMentoring?: boolean;
  linkedinUrl?: string;
  githubUrl?: string;
  website?: string;
}


export const getMyProfile = async () => {
  const res = await api.get("/api/profile/me");
  return res.data;
};

export const getProfileByUserId = async (userId: number) => {
  const res = await api.get(`/api/profile/${userId}`);
  return res.data;
};

export const updateMyProfile = async (profile: ProfileUpdatePayload) => {
  const res = await api.put("/api/profile/me", profile);
  return res.data;
};

export const saveAvatarUrl = async (avatarUrl: string) => {
  const res = await api.put("/api/profile/me/avatar", { avatarUrl });
  return res.data;
};

export const uploadMyCv = async (file: File) => {
  const form = new FormData();
  form.append("file", file);

  const res = await api.put("/api/profile/me/cv/upload", form, {
    headers: { "Content-Type": "multipart/form-data" }
  });

  return res.data as { cvUrl: string };
};

export const openCv = async (cvUrl: string) => {
  const res = await api.get(cvUrl, { responseType: "blob" });

  const blob = new Blob([res.data], {
    type: res.headers["content-type"] || "application/octet-stream"
  });

  const url = window.URL.createObjectURL(blob);
  window.open(url, "_blank", "noopener,noreferrer");

  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};